var _g, _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.00 0.00 144.00 142.00",
    width: 144,
    height: 142,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "butt"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#faa19b",
    d: " M 31.37 89.63 A 10.88 10.88 0.0 0 0 40.79 105.95 L 103.21 105.95 A 10.88 10.88 0.0 0 0 112.63 89.63 L 81.42 35.57 A 10.88 10.88 0.0 0 0 62.58 35.57 L 31.37 89.63"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#faa19b",
    d: " M 103.21 100.92 A 5.87 5.87 0.0 0 0 108.29 92.11 L 77.12 38.13 A 5.87 5.87 0.0 0 0 66.96 38.13 L 35.79 92.11 A 5.87 5.87 0.0 0 0 40.87 100.91 L 103.21 100.92"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#faa19b",
    d: " M 37.61 93.45 A 3.82 3.82 0.0 0 0 40.92 99.17 L 102.86 99.17 A 3.82 3.82 0.0 0 0 106.17 93.45 L 75.20 39.38 A 3.82 3.82 0.0 0 0 68.58 39.38 L 37.61 93.45"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#faa19b",
    d: " M 71.89 81.27 C 74.58 81.27 76.38 79.15 76.53 76.51 Q 76.94 68.97 77.59 56.77 C 77.78 53.30 77.43 50.76 73.76 50.03 Q 73.58 49.99 71.89 49.99 Q 70.21 49.99 70.03 50.03 C 66.36 50.76 66.01 53.30 66.19 56.77 Q 66.84 68.97 67.25 76.51 C 67.39 79.15 69.20 81.27 71.89 81.27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#faa19b",
    d: " M 75.89 90.47 A 3.99 3.99 0.0 0 0 71.90 86.48 A 3.99 3.99 0.0 0 0 67.91 90.47 A 3.99 3.99 0.0 0 0 71.90 94.46 A 3.99 3.99 0.0 0 0 75.89 90.47"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: " M 75.71 0.00 Q 101.92 1.69 120.62 18.63 Q 141.46 37.49 144.00 66.41 L 144.00 74.63 Q 141.91 103.93 120.89 123.14 Q 102.17 140.24 75.83 142.00 L 67.90 142.00 Q 41.98 140.16 23.50 123.50 Q 2.21 104.31 0.00 74.83 L 0.00 66.91 Q 1.57 45.64 13.41 29.66 Q 33.29 2.85 67.75 0.00 L 75.71 0.00 Z M 31.37 89.63 A 10.88 10.88 0.0 0 0 40.79 105.95 L 103.21 105.95 A 10.88 10.88 0.0 0 0 112.63 89.63 L 81.42 35.57 A 10.88 10.88 0.0 0 0 62.58 35.57 L 31.37 89.63 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: " M 31.37 89.63 L 62.58 35.57 A 10.88 10.88 0.0 0 1 81.42 35.57 L 112.63 89.63 A 10.88 10.88 0.0 0 1 103.21 105.95 L 40.79 105.95 A 10.88 10.88 0.0 0 1 31.37 89.63 Z M 103.21 100.92 A 5.87 5.87 0.0 0 0 108.29 92.11 L 77.12 38.13 A 5.87 5.87 0.0 0 0 66.96 38.13 L 35.79 92.11 A 5.87 5.87 0.0 0 0 40.87 100.91 L 103.21 100.92 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: " M 103.21 100.92 L 40.87 100.91 A 5.87 5.87 0.0 0 1 35.79 92.11 L 66.96 38.13 A 5.87 5.87 0.0 0 1 77.12 38.13 L 108.29 92.11 A 5.87 5.87 0.0 0 1 103.21 100.92 Z M 37.61 93.45 A 3.82 3.82 0.0 0 0 40.92 99.17 L 102.86 99.17 A 3.82 3.82 0.0 0 0 106.17 93.45 L 75.20 39.38 A 3.82 3.82 0.0 0 0 68.58 39.38 L 37.61 93.45 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: " M 37.61 93.45 L 68.58 39.38 A 3.82 3.82 0.0 0 1 75.20 39.38 L 106.17 93.45 A 3.82 3.82 0.0 0 1 102.86 99.17 L 40.92 99.17 A 3.82 3.82 0.0 0 1 37.61 93.45 Z M 71.89 81.27 C 74.58 81.27 76.38 79.15 76.53 76.51 Q 76.94 68.97 77.59 56.77 C 77.78 53.30 77.43 50.76 73.76 50.03 Q 73.58 49.99 71.89 49.99 Q 70.21 49.99 70.03 50.03 C 66.36 50.76 66.01 53.30 66.19 56.77 Q 66.84 68.97 67.25 76.51 C 67.39 79.15 69.20 81.27 71.89 81.27 Z M 75.89 90.47 A 3.99 3.99 0.0 0 0 71.90 86.48 A 3.99 3.99 0.0 0 0 67.91 90.47 A 3.99 3.99 0.0 0 0 71.90 94.46 A 3.99 3.99 0.0 0 0 75.89 90.47 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: " M 71.89 49.99 Q 73.58 49.99 73.76 50.03 C 77.43 50.76 77.78 53.30 77.59 56.77 Q 76.94 68.97 76.53 76.51 C 76.38 79.15 74.58 81.27 71.89 81.27 C 69.20 81.27 67.39 79.15 67.25 76.51 Q 66.84 68.97 66.19 56.77 C 66.01 53.30 66.36 50.76 70.03 50.03 Q 70.21 49.99 71.89 49.99 Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#f44336",
    cx: 71.9,
    cy: 90.47,
    r: 3.99
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedWarning);
export default __webpack_public_path__ + "static/media/red-warning.e2f77acc672ce5e52f807d3798688fd4.svg";
export { ForwardRef as ReactComponent };